
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal/group-trip",
      function () {
        return require("private-next-pages/personal/group-trip/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal/group-trip"])
      });
    }
  